module.exports = __webpack_public_path__ + "static/media/three_dots_horizontal.f81b53e9.svg";